import { Alert, AlertProps } from '@mui/material';

type PricingGuidanceAlertProps = AlertProps;

/** Informational alert explaining portal MTA pricing matches contact-centre quotes. */
export const PricingGuidanceAlert = (props: PricingGuidanceAlertProps) => (
	<Alert severity='info' {...props}>
		Please note the price shown is the same price you would be quoted if you made this change by calling our customer
		service team. Need assistance? Speak to our virtual assistant or give us a call.
	</Alert>
);
